module.exports = __webpack_public_path__ + "img/a9_04.8f992d3b.jpg";